import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon48 } from 'builder/components/Icon'
import Media from 'builder/styles/media'
import { ButtonV2 } from 'builder/components/Button'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`

export const HeroContainer = styled.div`
  width: 100%;
  max-width: 1120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  padding: unset;

  ${Media.Desktop`
    flex-direction: row;
    padding: 0 40px;
    gap: 72px;
  `}
`

export const HeroInformationWrapper = styled.div`
  width: 100%;
  min-width: 389px;
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  ${Media.Desktop`
    padding: unset;
    width: 400px;
  `}
`

export const HeroGhostTitle = styled.p`
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral50};
  margin-bottom: ${Spacing.S};
`

export const HeroTitle = styled.p`
  ${Typography.L};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
  margin-bottom: 12px;
`

export const HeroDescription = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
  margin-bottom: ${Spacing.L};
`

export const BenefitsContainer = styled.div`
  width: 100%;
  max-width: 1120px;
  display: flex;
  flex-direction: column;
  padding: 0 20px 100px;

  ${Media.AbovePhone`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  `}

  ${Media.AboveTablet`
    gap: 54px;
    padding: 0 40px;
    display: flex;
    flex-direction: row;
    margin-top: 24px;
  `}

  ${Media.Phone`
    display: flex;
    flex-direction: column;
    gap: 40px;
  `}
`

export const BenefitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const BenefitIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  color: ${Colors.Neutral90};
  margin-bottom: 16px;
`

export const IconPeople = styled(Icon48.PeopleIcon)`
  width: 48px;
  height: 48px;
  color: ${Colors.Neutral90};
`

export const IconTarget = styled(Icon48.TargetIcon)`
  width: 48px;
  height: 48px;
  color: ${Colors.Neutral90};
`

export const IconHeartMessage = styled(Icon48.HeartMessageIcon)`
  width: 48px;
  height: 48px;
  color: ${Colors.Neutral90};
`

export const BenefitTitle = styled.p`
  ${Typography.Subhead};
  ${FontWeights.Medium};
  color: ${Colors.Neutral100};
  margin-bottom: ${Spacing['2XS']};
`

export const BenefitDescription = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const HeroImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const HeroImage = styled.img`
  width: 100%;

  ${Media.AboveTablet`
    max-width: 644px;
  `}
`

export const ContinueButton = styled(ButtonV2)`
  position: fixed;
  bottom: 100px;
  left: 20px;
  right: 20px;

  ${Media.AbovePhone`
   bottom: 40px;
  `}

  ${Media.AboveTablet`
    position: relative;
    bottom: unset;
    left: unset;
    right: unset;
    width: fit-content;
  `}
`
